  (function() {
    const TARGET_RULE_IDS = []; 

    const isHu = window.Shopify && window.Shopify.locale === "hu";
    const txtSearchPlaceholder = isHu ? "Termékek keresése..." : "Search products...";

    function isTargetRule(rule) {
      if (!rule) return false;
      try {
        if (TARGET_RULE_IDS.length > 0 && TARGET_RULE_IDS.includes(Number(rule.id))) {
          return true;
        }
        if (Number(rule.gift_qty) === 3 && rule.gift_type === 'collection' && !rule.is_gift_qty_fixed) {
          return true;
        }
      } catch (e) {
        console.error("Free Gift Custom - Error checking rule:", e);
      }
      return false;
    }

    const checkWidgetsInterval = setInterval(() => {
      try {
        if (window.tlFreeGiftOffer && window.tlFreeGiftOffer.popupWidget) {
          const popupWidget = window.tlFreeGiftOffer.popupWidget;
          if (!popupWidget._isOverridden) {
            const originalUpdateSelectedGift = popupWidget.updateSelectedGift;
            popupWidget.updateSelectedGift = function(rule, giftId, quantity) {
              try {
                if (isTargetRule(rule)) {
                  const targetQty = Math.min(quantity, 1); // Giới hạn số lượng mỗi quà = 1
                  return originalUpdateSelectedGift.call(this, rule, giftId, targetQty);
                }
              } catch (err) {
                console.error("Free Gift Custom - Error in updateSelectedGift override:", err);
              }
              return originalUpdateSelectedGift.call(this, rule, giftId, quantity);
            };

            // Ghi đè hàm hiển thị popup để dịch placeholder ô tìm kiếm của Popup
            const originalShowOffer = popupWidget.showOffer;
            popupWidget.showOffer = function(args) {
              const result = originalShowOffer.call(this, args);
              try {
                const searchInput = this.modalEle ? this.modalEle.querySelector(".salepify-popup__search-input") : null;
                if (searchInput) {
                  searchInput.placeholder = txtSearchPlaceholder;
                }
              } catch (err) {
                console.error("Free Gift Custom - Error translating popup search input:", err);
              }
              return result;
            };

            popupWidget._isOverridden = true;
          }
        }

        if (window.tlGiftInCartWidget) {
          const cartWidget = window.tlGiftInCartWidget;
          if (!cartWidget._isOverridden) {
            const originalSet = cartWidget.selectedGiftQuantitiesByRuleKey.set;
            cartWidget.selectedGiftQuantitiesByRuleKey.set = function(key, val) {
              try {
                const offerId = key.split('_').pop();
                const offer = cartWidget.getOfferByIdAndModule(offerId, 'free-gift');
                if (offer && isTargetRule(offer)) {
                  if (val && typeof val === 'object') {
                    Object.keys(val).forEach(k => {
                      if (val[k] > 1) val[k] = 1; 
                    });
                  }
                }
              } catch (err) {
                console.error("Free Gift Custom - Error in cart quantities set override:", err);
              }
              return originalSet.call(this, key, val);
            };

            const originalHandleIncreaseGiftQuantity = cartWidget.handleIncreaseGiftQuantity;
            cartWidget.handleIncreaseGiftQuantity = function(buttonElement, giftId, offerId, offerModule) {
              try {
                const offer = this.getOfferByIdAndModule(offerId, offerModule);
                if (offer && isTargetRule(offer)) {
                  const ruleKey = this.utils.getRuleKey(offerId, offerModule);
                  const selectedGifts = this.selectedGiftQuantitiesByRuleKey.get(ruleKey) ?? {};
                  const currentQty = selectedGifts[giftId] ?? 0;
                  if (currentQty >= 1) return;
                }
              } catch (err) {
                console.error("Free Gift Custom - Error in handleIncreaseGiftQuantity override:", err);
              }
              return originalHandleIncreaseGiftQuantity.call(this, buttonElement, giftId, offerId, offerModule);
            };

            const originalHandleChangeGiftQuantity = cartWidget.handleChangeGiftQuantity;
            cartWidget.handleChangeGiftQuantity = function(inputElement, giftId, offerId, offerModule) {
              try {
                const offer = this.getOfferByIdAndModule(offerId, offerModule);
                if (offer && isTargetRule(offer)) {
                  let val = parseInt(inputElement.value, 10);
                  if (val > 1) inputElement.value = 1;
                }
              } catch (err) {
                console.error("Free Gift Custom - Error in handleChangeGiftQuantity override:", err);
              }
              return originalHandleChangeGiftQuantity.call(this, inputElement, giftId, offerId, offerModule);
            };

            // Ghi đè hàm hiển thị cart widget để dịch placeholder ô tìm kiếm của Gift In Cart
            const originalUpdateGiftSelectorModal = cartWidget.updateGiftSelectorModal;
            cartWidget.updateGiftSelectorModal = async function(offer) {
              const result = await originalUpdateGiftSelectorModal.call(this, offer);
              try {
                const ruleKey = this.utils.getRuleKey(offer.id, offer.module);
                const container = document.querySelector(`.salepify-gic__gift-selector-container[data-rule-key="${ruleKey}"]`);
                const searchInput = container ? container.querySelector(".salepify-gic__gift-selector-search") : null;
                if (searchInput) {
                  searchInput.placeholder = txtSearchPlaceholder;
                }
              } catch (err) {
                console.error("Free Gift Custom - Error translating cart search input:", err);
              }
              return result;
            };

            cartWidget._isOverridden = true;
          }
        }
        if (
          window.tlFreeGiftOffer && window.tlFreeGiftOffer.popupWidget && window.tlFreeGiftOffer.popupWidget._isOverridden &&
          window.tlGiftInCartWidget && window.tlGiftInCartWidget._isOverridden
        ) {
          clearInterval(checkWidgetsInterval);
        }
      } catch (globalError) {
        console.error("Free Gift Custom - Global error in override loop:", globalError);
      }
    }, 200);
  })();
